import { Button, SxProps, Theme } from '@mui/material';


type WhatsAppContactProps = {
  buttonText: string;
  sx?: SxProps<Theme>;
  color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
};

export default function WhatsAppButton({ buttonText, color, sx }: WhatsAppContactProps) {

  const phone = '393793045608'; 
  const defaultMessage = encodeURIComponent('Ciao, ho un problema...');

  return (
        <Button
            variant="contained"
            color={color}
            sx={sx}
            href={`https://wa.me/${phone}?text=${defaultMessage}`}
            target="_blank"
            rel="noopener noreferrer"
        >
            {buttonText}
        </Button>
  );
}
